export default `
# ลำต้นที่เปลี่ยนแปลงไปทำหน้าที่พิเศษ

## ลำต้นเหนือดิน (aerial stem/terrestrial stem)

### Creeping Stem

ลำต้นที่ทอดหรือเลื้อยขนานไปตามผิวดินหรือผิวน้ำ เช่น ผักบุ้ง ผักกระเฉด ฟักทอง สตรอเบอรี่ หญ้า
![Creeping Stem](stemModifiedCreeping)

### Climbing stem

ลำต้นที่ไต่ขึ้นที่สูงโดยวิธีใดวิธีหนึ่ง ถ้ามีหลักหรือต้นไม้ที่ลำต้นตั้งตรงอยู่ใกล้ๆจะถูกใช้ ไต่ขึ้นไป แบ่งออกเป็น

1.  Twining stem  
    ลำต้นไต่ขึ้นที่สูงโดยใช้ลำต้นพันกับหลักเป็นเกลียว เช่น เถาวัลย์ ต้นถั่ว บอระเพ็ด ฝอยทอง
    ![Twining stem](stemModifiedTwining)

2.  Stem Tendril  
    ลำต้นไต่ขึ้นที่สูงโดยใช้ส่วนของลำต้นดัดแปลงไปเป็นมือเกาะ (tendril) เพื่อพันหรือไต่ขึ้นที่สูง ส่วนของ tendril จะบิดเป็นเกลียวคล้ายสปริงเพื่อให้ยืดหยุ่น เช่น ต้นองุ่น บวบ แตงกวา กระทกรก โคกกระออม พวงชมพู
    ![Stem tendril](stemModifiedTendril)

3.  Root climber  
    ลำต้นไต่ขึ้นที่สูงโดยใช้ราก ซึ่งออกมาตามข้อ ยึดหลักหรือต้นไม้ เช่น ต้นพริกไทย พลู พลูด่าง
    ![Root climber](stemModifiedRootClimber)

4.  Stem spine หรือ Stem thorn  
    ลำต้นที่ดัดแปลงไปเป็นหนามหรือขอเกี่ยว (hook) เพื่อไต่ขึ้นที่สูง เช่น ต้นเฟื้องฟ้า ไผ่ ไมยราบ พืชตระกูลส้ม
    ![Stem spine](stemModifiedSpine)

### Cladophyll / phylloclade / cladode

ลำต้นที่เปลี่ยนแปลงไปมีลักษณะหรือหน้าที่คล้ายใบ เช่น ลำต้นแป็นแผ่นแบน หรือมีสีเขียวของคลอโรฟีลล์ เช่น กระบองเพชร พญาไร้ใบ หน่อไม้ฝรั่ง โปร่งฟ้า สนประดิพัทธ์
![Cladophyll](stemModifiedCladophyll)

### Bulbil / crown / slip

ลำต้นที่เป็นตาหรือหน่อเล็กๆ สั้นๆ ที่ประกอบด้วยยอดอ่อนและใบเล็กๆ 2-3 ใบ แตกออกระหว่างซอกใบกับลำต้น หรือแตกออกจากยอดของลำต้นแทนดอก เมื่อมันหลุดร่วงลงดินก็สามารถเจริญเป็นต้นใหม่ได้ เช่น หอม กระเทียม สับปะรด เป็นต้น
![Bubil](stemModifiedBubil)

## ลำต้นใต้ดิน (underground stem)

### Rhizome

ลำต้นใต้ดินที่เรียกกันว่า แง่ง หรือเหง้า ส่วนใหญ่ขนานกับพื้นดิน มีข้อปล้องเห็นได้ชัดเจน ตามข้อมีใบที่เป็นแปลงเป็นสีน้ำตาล ได้แก่ ขิง ข่า ขมิ้น บางชนิดอาจตั้งตรง เช่น กล้วย พุทธรักษา เป็นต้น
![Rhizome](stemModifiedRhizome)

### Tuber

เป็นลำต้นใต้ดินที่สะสมอาหาร ทำให้อวบอ้วน แต่บริเวณที่เป็นตาจะไม่อ้วนออกมาด้วย ทำให้เห็นเป็นรอยบุ๋ม ได้แก่ มันฝรั่ง
![Tuber](stemModifiedTuber)

### Bulb

เป็นลำต้นใต้ดินที่ลำต้นเล็กมีปล้องสั้นมาก ตามปล้องมีใบเกล็ดซ้อนกันหลายๆชั้นห่อหุ้มลำต้นเอาไว้และสะสมอาหาร เช่น หอม กระเทียม
![Bulb](stemModifiedBulb)

### Corm

เป็นลำต้นใต้ดินที่ตั้งตรง เช่นเดียวกับ bulb มีลักษณะคล้ายกันแต่เก็บสะสมอาหารไว้ในลำต้นจนทำให้เห็นลำต้นอวบอ้วน ตามข้อมีใบเกล็ดบางๆหุ้ม มีตางอกตามข้อ เช่น เผือก แห้วจีน
![Corm](stemModifiedCorm)
`


// WEBPACK FOOTER //
// ./src/pages/Stem/stemModifiedMarkdown.js